import { forwardRef, useCallback, useImperativeHandle, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { PresentUrl, esiFormApi, selfOnboardDataFetchApi } from "../../../text/apidata.js";
import { setSelfonboardingDataFetchResponse } from "../../../Redux/Slice.js";
import { store } from "../../../Redux/Store.js";
import { getLoaderAction2 } from "../../../Redux/Loader2.js";
import {
  selectEmployeeInformation,
  updateEsiField,
  addNominee,
  updateNomineeField,
  setNomineeImage,
  removeNominee,
  removeNomineeImage,
} from "../../../Redux/employeeInformationSlice.js";
import styles from "./EsiForm.module.scss";

const PF_OPTIONS = [100, 75, 50, 25, 0];

const EsiForm = forwardRef(function EsiForm(_, ref) {
  const dispatch = useDispatch();

  const { esiDetails, basicInformation, addressDetails, bankDetails } =
    useSelector(selectEmployeeInformation);

  const selfonboardData = useSelector(
    (state) => state.selfonboardingretriveslice?.Selfonboarding_Data
  );
  const selfonboardDataFetch = useSelector(
    (state) => state.selfonboarddatafetchslice?.Selfonboarding_DataFetch_Data
  );
  const employeeDetails = useSelector(
    (state) => state.Signature_Employee_RetrieveCall_actions?.Signature_Employee_Datas
  );

  const nominees = esiDetails.nominees || [];
  const [errorFields, setErrorFields] = useState(new Set());
  const [nomineeErrors, setNomineeErrors] = useState({});

  const extractEsiFormId = (d) => {
    if (!d) return null;
    const raw =
      d?.employeetimeline_id?.esi_form ||
      d?.employeetimeline_id?.esi_details_form ||
      d?.esi_details_form?.id ||
      d?.esi_details_form ||
      d?.esi_form_id ||
      d?.esi_form ||
      d?.esiform_id;

    if (typeof raw === "object" && raw !== null) {
      return raw.id || raw._id || null;
    }
    return raw ? String(raw) : null;
  };

  const fetchedEsiFormIdRef = useRef(null);

  // GET ESI Form API on mount
  useEffect(() => {
    const details = selfonboardDataFetch || selfonboardData || employeeDetails;
    if (!details) {
      dispatch(getLoaderAction2(false));
      return;
    }

    const esiFormId = extractEsiFormId(details);
    if (!esiFormId) {
      const fatherNameVal = details.FatherORHUSBANDNAME || details.father_or_husband_name || (details.father_husband_name ? details.father_husband_name.split("@@@@####@@@@")[0] : "") || details.father_name || "";
      const fatherRelVal = (details.father_husband_name && details.father_husband_name.includes("@@@@####@@@@")) ? details.father_husband_name.split("@@@@####@@@@")[1] : (details.NameOfFamliy || "Father");

      const fieldMap = {
        NameOfFamliy: fatherRelVal ? String(fatherRelVal).charAt(0).toUpperCase() + String(fatherRelVal).slice(1).toLowerCase() : "Father",
        FatherORHUSBANDNAME: fatherNameVal,
        gender: details.gender || basicInformation.gender || details.esi_form?.gender || "",
        marital_status: details.marital_status ? String(details.marital_status).toUpperCase() : (details.esi_form?.marital_status ? String(details.esi_form.marital_status).toUpperCase() : ""),
        date_of_joining: details.date_of_joining || details.doj || details.esi_form?.date_of_joining || "",
        account_number: details.account_number || details.bank_acc_ifsc || details.bank_acc_no || details.bank_details?.account_number || details.esi_form?.account_number || "",
        address_permanent: details.address_permanent || details.permanent_address || details.address_details?.permanent_address || details.esi_form?.address_permanent || "",
        address_temporary: details.address_temporary || details.present_address || details.address_details?.present_address || details.esi_form?.address_temporary || "",
        previous_ESI_number: details.previous_ESI_number || details.esi_number || details.esi_form?.previous_ESI_number || "",
        esi_dispensary: details.esi_dispensary || details.esi_form?.esi_dispensary || "",
        // esi_id_card: details.esi_id_card || details.esi_form?.esi_id_card || "", // ESI ID card hidden in self onboarding
        e_p_f: details.e_p_f || details.esi_form?.e_p_f || "",
        e_p_s: details.e_p_s || details.esi_form?.e_p_s || "",
      };

      Object.entries(fieldMap).forEach(([name, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          dispatch(updateEsiField({ name, value }));
        }
      });

      if (fetchedEsiFormIdRef.current === "DATA_FETCH") {
        dispatch(getLoaderAction2(false));
        return;
      }
      fetchedEsiFormIdRef.current = "DATA_FETCH";

      const sessionToken =
        details?.session_token ||
        details?.token ||
        details?.sessionToken ||
        store?.getState()?.users?.UserData?.session?.token ||
        localStorage.getItem("token") ||
        localStorage.getItem("session_token");

      if (sessionToken) {
        const headers = {
          Authorization: String(sessionToken).startsWith("Bearer ")
            ? sessionToken
            : `Bearer ${sessionToken}`,
        };

        dispatch(getLoaderAction2(true));
        axios
          .get(selfOnboardDataFetchApi, { headers })
          .then((res) => {
            console.log("selfOnboardDataFetchApi response in EsiForm:", res.data);
            const data = res.data?.data || res.data;
            if (data) {
              dispatch(setSelfonboardingDataFetchResponse(data));

              const resFatherNameVal = data.FatherORHUSBANDNAME || data.father_or_husband_name || (data.father_husband_name ? data.father_husband_name.split("@@@@####@@@@")[0] : "") || data.father_name || "";
              const resFatherRelVal = (data.father_husband_name && data.father_husband_name.includes("@@@@####@@@@")) ? data.father_husband_name.split("@@@@####@@@@")[1] : (data.NameOfFamliy || "Father");

              const resFieldMap = {
                NameOfFamliy: resFatherRelVal ? String(resFatherRelVal).charAt(0).toUpperCase() + String(resFatherRelVal).slice(1).toLowerCase() : "Father",
                FatherORHUSBANDNAME: resFatherNameVal,
                gender: data.gender || basicInformation.gender || data.esi_form?.gender || "",
                marital_status: data.marital_status ? String(data.marital_status).toUpperCase() : (data.esi_form?.marital_status ? String(data.esi_form.marital_status).toUpperCase() : ""),
                date_of_joining: data.date_of_joining || data.doj || data.esi_form?.date_of_joining || "",
                account_number: data.account_number || data.bank_acc_ifsc || data.bank_acc_no || data.bank_details?.account_number || data.esi_form?.account_number || "",
                address_permanent: data.address_permanent || data.permanent_address || data.address_details?.permanent_address || data.esi_form?.address_permanent || "",
                address_temporary: data.address_temporary || data.present_address || data.address_details?.present_address || data.esi_form?.address_temporary || "",
                previous_ESI_number: data.previous_ESI_number || data.esi_number || data.esi_form?.previous_ESI_number || "",
                esi_dispensary: data.esi_dispensary || data.esi_form?.esi_dispensary || "",
                // esi_id_card: data.esi_id_card || data.esi_form?.esi_id_card || "", // ESI ID card hidden in self onboarding
                e_p_f: data.e_p_f || data.esi_form?.e_p_f || "",
                e_p_s: data.e_p_s || data.esi_form?.e_p_s || "",
              };

              Object.entries(resFieldMap).forEach(([name, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  dispatch(updateEsiField({ name, value }));
                }
              });
            }
          })
          .catch((err) => {
            console.error("Error fetching selfOnboardDataFetchApi in EsiForm:", err);
          })
          .finally(() => {
            dispatch(getLoaderAction2(false));
          });
      } else {
        dispatch(getLoaderAction2(false));
      }
      return;
    }

    if (fetchedEsiFormIdRef.current === esiFormId) {
      dispatch(getLoaderAction2(false));
      return;
    }
    fetchedEsiFormIdRef.current = esiFormId;

    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    dispatch(getLoaderAction2(true));

    axios
      .get(`${esiFormApi}${esiFormId}/`, { headers })
      .then((res) => {
        console.log("ESI form GET API response:", res.data);
        const data = res.data?.data || res.data;
        if (data) {
          const fatherNameVal = data.FatherORHUSBANDNAME || data.father_or_husband_name || (data.father_husband_name ? data.father_husband_name.split("@@@@####@@@@")[0] : "") || "";
          const fatherRelVal = (data.father_husband_name && data.father_husband_name.includes("@@@@####@@@@")) ? data.father_husband_name.split("@@@@####@@@@")[1] : (data.NameOfFamliy || "Father");

          const fieldMap = {
            NameOfFamliy: fatherRelVal ? String(fatherRelVal).charAt(0).toUpperCase() + String(fatherRelVal).slice(1).toLowerCase() : "Father",
            FatherORHUSBANDNAME: fatherNameVal,
            gender: data.gender || basicInformation.gender || "",
            marital_status: data.marital_status ? String(data.marital_status).toUpperCase() : "",
            date_of_joining: data.date_of_joining || "",
            e_p_f: data.e_p_f || "",
            e_p_s: data.e_p_s || "",
            previous_ESI_number: data.previous_ESI_number || data.esi_number || "",
            esi_dispensary: data.esi_dispensary || "",
            // esi_id_card: data.esi_id_card || "", // ESI ID card hidden in self onboarding
            account_number: data.account_number || "",
            address_permanent: data.address_permanent || "",
            address_temporary: data.address_temporary || "",
          };

          Object.entries(fieldMap).forEach(([name, value]) => {
            if (value !== undefined && value !== null) {
              dispatch(updateEsiField({ name, value }));
            }
          });

          // Parse 4 Nominees from flat API response or nominees array
          const parseNomObj = (nameAddr, rel, dob, minor, pct, imgObj) => {
            if (!nameAddr && !rel && !dob && !minor && !pct && !imgObj) return null;
            let name = "";
            let address = "";
            if (nameAddr && typeof nameAddr === "string") {
              if (nameAddr.includes("@@@@####@@@@")) {
                const parts = nameAddr.split("@@@@####@@@@");
                name = parts[0] ? parts[0].trim() : "";
                address = parts[1] ? parts[1].trim() : "";
              } else {
                name = nameAddr.trim();
              }
            }
            const imgUrl = typeof imgObj === "object" && imgObj !== null ? imgObj.media_url || imgObj.url : (typeof imgObj === "string" ? imgObj : "");
            const formattedRel = rel ? String(rel).charAt(0).toUpperCase() + String(rel).slice(1).toLowerCase() : "";

            if (!name && !address && !formattedRel && !dob && !imgUrl) return null;

            return {
              name,
              address,
              relationship: formattedRel,
              dob: dob || "",
              guardian: minor || "",
              share: pct !== null && pct !== undefined ? String(pct) : "",
              imgUrl,
            };
          };

          let parsedNomineesList = [];
          if (Array.isArray(data.nominees) && data.nominees.length > 0) {
            parsedNomineesList = data.nominees.map((n, idx) => ({
              id: Date.now() + idx,
              name: n.name || "",
              address: n.address || "",
              relationship: n.relationship || "",
              dob: n.dob || "",
              guardian: n.guardian || "",
              share: n.share !== undefined ? String(n.share) : "",
              image: (n.image?.media_url || n.image?.url || (typeof n.image === "string" ? n.image : null)) ? {
                name: "Nominee Document",
                url: n.image?.media_url || n.image?.url || (typeof n.image === "string" ? n.image : ""),
                s3Url: n.image?.media_url || n.image?.url || (typeof n.image === "string" ? n.image : ""),
              } : null,
            }));
          } else {
            const n1 = parseNomObj(data.nominee_name_address, data.nominee_relationship, data.nominee_dob, data.if_nominee_minor, data.percentage, data.nominee_image);
            const n2 = parseNomObj(data.second_nominee_name_address, data.second_nominee_relationship, data.second_nominee_dob, data.second_if_nominee_minor, data.second_percentage, data.second_nominee_image);
            const n3 = parseNomObj(data.third_nominee_name_address, data.third_nominee_relationship, data.third_nominee_dob, data.third_if_nominee_minor, data.third_percentage, data.third_nominee_image);
            const n4 = parseNomObj(data.fourth_nominee_name_address, data.fourth_nominee_relationship, data.fourth_nominee_dob, data.fourth_if_nominee_minor, data.fourth_percentage, data.fourth_nominee_image);

            parsedNomineesList = [n1, n2, n3, n4].filter(Boolean).map((n, idx) => ({
              id: Date.now() + idx,
              name: n.name,
              address: n.address,
              relationship: n.relationship,
              dob: n.dob,
              guardian: n.guardian,
              share: n.share,
              image: n.imgUrl ? {
                name: "Nominee Document",
                url: n.imgUrl,
                s3Url: n.imgUrl,
              } : null,
            }));
          }

          if (parsedNomineesList.length > 0) {
            dispatch(updateEsiField({ name: "nominees", value: parsedNomineesList }));
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching ESI form GET API:", err);
      })
      .finally(() => {
        dispatch(getLoaderAction2(false));
      });
  }, [dispatch, selfonboardData, employeeDetails]);

  const currentGender = esiDetails.gender || basicInformation.gender || "";
  const isMale = String(currentGender).trim().toLowerCase() === "male";

  useEffect(() => {
    if (basicInformation.gender && !esiDetails.gender) {
      dispatch(updateEsiField({ name: "gender", value: basicInformation.gender }));
    }
  }, [basicInformation.gender, esiDetails.gender, dispatch]);

  useEffect(() => {
    if (isMale && (esiDetails.NameOfFamliy === "Husband" || esiDetails.NameOfFamliy === "husband")) {
      dispatch(updateEsiField({ name: "NameOfFamliy", value: "Father" }));
    }
  }, [isMale, esiDetails.NameOfFamliy, dispatch]);

  const clearError = (name) => {
    setErrorFields((prev) => {
      const next = new Set(prev);
      next.delete(name);
      return next;
    });
  };

  const clearNomineeError = (id, name) => {
    setNomineeErrors((prev) => {
      const entryErrors = new Set(prev[id]);
      entryErrors.delete(name);
      return { ...prev, [id]: entryErrors };
    });
  };

  const updateField = (name, value) => {
    dispatch(updateEsiField({ name, value }));
    clearError(name);
  };

  const updateNominee = (id, name, value) => {
    dispatch(updateNomineeField({ id, name, value }));
    clearNomineeError(id, name);
  };

  const handleImage = async (id, file) => {
    if (!file || file.size > 10 * 1024 * 1024) return;

    const nominee = nominees.find((n) => n.id === id);
    if (nominee?.image?.url) {
      URL.revokeObjectURL(nominee.image.url);
    }

    const localUrl = URL.createObjectURL(file);

    dispatch(
      setNomineeImage({
        id,
        image: {
          name: file.name,
          url: localUrl,
          s3Url: "",
        },
      })
    );

    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    dispatch(getLoaderAction2(true));

    try {
      const folderName = "nominee";
      const randomNumber = Math.floor(Math.random() * 10000000000);
      const fileExt = file.name.split(".").pop() || "jpg";
      const formattedFilename = `onboarding/${folderName}/${folderName}${randomNumber}.${fileExt}`;

      const presignedReqData = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type || "image/jpeg",
          },
        ],
      };

      const presignedRes = await axios.post(PresentUrl, presignedReqData, { headers });
      const uploadedUrls = presignedRes.data?.data || presignedRes.data;

      let s3CleanUrl = "";
      if (Array.isArray(uploadedUrls) && uploadedUrls.length > 0) {
        const presignedPutUrl = uploadedUrls[0];
        s3CleanUrl = String(presignedPutUrl).split("?")[0];

        await fetch(presignedPutUrl, {
          method: "PUT",
          headers: {
            "Content-Type": file.type || "image/jpeg",
            "x-amz-acl": "public-read",
          },
          body: file,
        });
      }

      const finalS3Url = s3CleanUrl || localUrl;

      dispatch(
        setNomineeImage({
          id,
          image: {
            name: file.name,
            url: finalS3Url,
            s3Url: finalS3Url,
          },
        })
      );
    } catch (err) {
      console.error("Presigned URL upload error for nominee image:", err);
    } finally {
      dispatch(getLoaderAction2(false));
    }
  };

  const handleRemoveImage = (id) => {
    const nominee = nominees.find((n) => n.id === id);
    if (nominee?.image?.url) {
      URL.revokeObjectURL(nominee.image.url);
    }
    dispatch(removeNomineeImage({ id }));
  };

  // ESI ID card hidden in self onboarding
  /*
  const handleEsiIdCard = async (file) => {
    if (!file || file.size > 10 * 1024 * 1024) return;

    if (String(esiDetails.esi_id_card || "").startsWith("blob:")) {
      URL.revokeObjectURL(esiDetails.esi_id_card);
    }

    const localUrl = URL.createObjectURL(file);
    updateField("esi_id_card", localUrl);

    const details = selfonboardData || employeeDetails;
    const sessionToken =
      details?.session_token ||
      details?.token ||
      details?.sessionToken ||
      store?.getState()?.users?.UserData?.session?.token;

    const headers = sessionToken
      ? {
        Authorization: String(sessionToken).startsWith("Bearer ")
          ? sessionToken
          : `Bearer ${sessionToken}`,
      }
      : {};

    dispatch(getLoaderAction2(true));

    try {
      const folderName = "esi_id_card";
      const randomNumber = Math.floor(Math.random() * 10000000000);
      const fileExt = file.name.split(".").pop() || "jpg";
      const formattedFilename = `onboarding/${folderName}/${folderName}${randomNumber}.${fileExt}`;

      const presignedReqData = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type || "image/jpeg",
          },
        ],
      };

      const presignedRes = await axios.post(PresentUrl, presignedReqData, { headers });
      const uploadedUrls = presignedRes.data?.data || presignedRes.data;

      let s3CleanUrl = "";
      if (Array.isArray(uploadedUrls) && uploadedUrls.length > 0) {
        const presignedPutUrl = uploadedUrls[0];
        s3CleanUrl = String(presignedPutUrl).split("?")[0];

        await fetch(presignedPutUrl, {
          method: "PUT",
          headers: {
            "Content-Type": file.type || "image/jpeg",
            "x-amz-acl": "public-read",
          },
          body: file,
        });
      }

      updateField("esi_id_card", s3CleanUrl || localUrl);
    } catch (err) {
      console.error("Presigned URL upload error for ESI ID card:", err);
    } finally {
      dispatch(getLoaderAction2(false));
    }
  };

  const handleRemoveEsiIdCard = () => {
    if (String(esiDetails.esi_id_card || "").startsWith("blob:")) {
      URL.revokeObjectURL(esiDetails.esi_id_card);
    }
    updateField("esi_id_card", "");
  };
  */

  const getAvailableOptions = (currentId) => {
    const totalExceptCurrent = nominees.reduce((sum, n) => {
      if (n.id === currentId) return sum;
      return sum + Number(n.share || 0);
    }, 0);

    const remaining = 100 - totalExceptCurrent;
    return PF_OPTIONS.filter((opt) => opt <= remaining);
  };

  const canAddNominee = () => {
    return nominees.length < 4;
  };

  const totalShare = nominees.reduce((sum, n) => sum + Number(n.share || 0), 0);

  const getMissingFields = useCallback(() => {
    const missing = [];
    const missingNames = new Set();
    const newNomineeErrors = {};

    if (!String(esiDetails.FatherORHUSBANDNAME || "").trim()) {
      missing.push(`Father / Husband Name`);
      missingNames.add("FatherORHUSBANDNAME");
    }

    // if (!esiDetails.gender && !basicInformation.gender) {
    //   missing.push("Gender");
    //   missingNames.add("gender");
    // }

    if (nominees.length === 0) {
      missing.push("At least one nominee is required");
    } else {
      nominees.forEach((n, index) => {
        const isFirst = index === 0;
        const hasAnyField = Boolean(
          n.name || n.address || n.relationship || n.share || n.dob || n.guardian || n.image
        );

        if (isFirst || hasAnyField) {
          const errSet = new Set();

          if (!String(n.name || "").trim()) {
            errSet.add("name");
            missing.push(`Nominee ${index + 1}: Name`);
          }

          if (!String(n.address || "").trim()) {
            errSet.add("address");
            missing.push(`Nominee ${index + 1}: Address`);
          }

          if (!String(n.relationship || "").trim()) {
            errSet.add("relationship");
            missing.push(`Nominee ${index + 1}: Relationship`);
          }

          if (n.share === undefined || n.share === null || String(n.share).trim() === "") {
            errSet.add("share");
            missing.push(`Nominee ${index + 1}: Share`);
          }

          if (!n.dob) {
            errSet.add("dob");
            missing.push(`Nominee ${index + 1}: Date of Birth`);
          }

          if (errSet.size > 0) {
            newNomineeErrors[n.id] = errSet;
          }
        }
      });
    }

    setErrorFields(missingNames);
    setNomineeErrors(newNomineeErrors);

    return missing;
  }, [esiDetails, nominees]);

  useImperativeHandle(ref, () => ({
    getMissingFields,
    isComplete: () => getMissingFields().length === 0,
  }));

  const hasNomineeError = (id, name) => nomineeErrors[id]?.has(name) ?? false;

  return (
    <div className={styles.esi}>
      <header className={styles.sectionHeader}>ESI Form</header>

      <div className={styles.content}>
        <div className={styles.formGrid}>
          <label className={styles.field}>
            <span>
              Name<b>*</b>
            </span>
            <input value={basicInformation.first_name} disabled />
          </label>
          {/* <label className={styles.field}>
            <span>
              Gender<b>*</b>
            </span>
            <div className={styles.inlineOptions}>
              {["Male", "Female", "Other"].map((g) => {
                const activeGender = esiDetails.gender || basicInformation.gender || "";
                const isChecked = String(activeGender).trim().toLowerCase() === g.toLowerCase();
                return (
                  <label key={g}>
                    <input
                      type="radio"
                      name="gender"
                      checked={isChecked}
                      onChange={() => updateField("gender", g)}
                    />
                    {g}
                  </label>
                );
              })}
            </div>
            {errorFields.has("gender") && (
              <p className={styles.fieldError}>Please select a gender</p>
            )}
          </label> */}
          <label className={styles.field}>
            <span>
              Relation<b>*</b>
              <span>
                <div className={styles.inlineOptions}>
                  {["Father", "Husband"].map((v) => {
                    const isDisabled = v === "Husband" && isMale;
                    return (
                      <label key={v} style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? "not-allowed" : "pointer" }}>
                        <input
                          type="radio"
                          name="relationType"
                          disabled={isDisabled}
                          checked={(esiDetails.NameOfFamliy || "Father") === v}
                          onChange={() => {
                            if (!isDisabled) {
                              updateField("NameOfFamliy", v);
                              updateField("FatherORHUSBANDNAME", "");
                            }
                          }}
                        />
                        {v}
                      </label>
                    );
                  })}
                </div>
              </span>
            </span>
            <input
              className={[
                styles.relationInput,
                errorFields.has("FatherORHUSBANDNAME") ? styles.inputError : "",
              ].join(" ")}
              placeholder={`Enter ${esiDetails.NameOfFamliy || "Father"} Name`}
              value={esiDetails.FatherORHUSBANDNAME || ""}
              onChange={(e) =>
                updateField("FatherORHUSBANDNAME", e.target.value.toUpperCase())
              }
            />
            {errorFields.has("FatherORHUSBANDNAME") && (
              <p className={styles.fieldError}>Please enter name</p>
            )}
          </label>

          {/* <label className={styles.field}>
            <span>Date of Birth</span>
            <input value={basicInformation.DateofBirth} disabled />
          </label> */}


          {/* 
          <label className={styles.field}>
            <span>Marital Status</span>
            <select
              value={esiDetails.marital_status || ""}
              onChange={(e) => updateField("marital_status", e.target.value)}
            >
              <option value="">Select</option>
              <option value="UNMARRIED">UNMARRIED</option>
              <option value="MARRIED">MARRIED</option>
              <option value="OTHERS">OTHERS</option>
            </select>
          </label> */}

          {(() => {
            const permAddrFromRedux = [
              addressDetails?.street_name1,
              addressDetails?.town_name1,
              addressDetails?.city_name1,
              addressDetails?.state_name1 && addressDetails.state_name1 !== "Select" ? addressDetails.state_name1 : "",
              addressDetails?.pin_code1,
            ]
              .filter(Boolean)
              .join(", ");

            const tempAddrFromRedux = [
              addressDetails?.street_name,
              addressDetails?.town_name,
              addressDetails?.city_name,
              addressDetails?.state_name && addressDetails.state_name !== "Select" ? addressDetails.state_name : "",
              addressDetails?.pin_code,
            ]
              .filter(Boolean)
              .join(", ");

            const displayPermAddress = permAddrFromRedux || esiDetails.address_permanent || "";
            const displayTempAddress = tempAddrFromRedux || esiDetails.address_temporary || "";
            const displayAccountNumber = bankDetails.account_number || esiDetails.account_number || "";

            return (
              <>
                {/* <label className={styles.field}>
                  <span>Account Number</span>
                  <input value={displayAccountNumber} disabled />
                </label>

                <label className={styles.field}>
                  <span>Address Permanent</span>
                  <input value={displayPermAddress} disabled />
                </label>

                <label className={styles.field}>
                  <span>Address Temporary</span>
                  <input value={displayTempAddress} disabled />
                </label> */}
              </>
            );
          })()}

          {/*
          <label className={styles.field}>
            <span>
              Date of Joining<b>*</b>
            </span>
            <input
              type="date"
              value={esiDetails.date_of_joining || ""}
              className={errorFields.has("date_of_joining") ? styles.inputError : ""}
              onChange={(e) => updateField("date_of_joining", e.target.value)}
            />
            {errorFields.has("date_of_joining") && (
              <p className={styles.fieldError}>Please select Date of Joining</p>
            )}
          </label>
          */}

          <label className={styles.field}>
            <span>E.P.F</span>
            <input
              value={esiDetails.e_p_f || ""}
              onChange={(e) => updateField("e_p_f", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>E.P.S</span>
            <input
              value={esiDetails.e_p_s || ""}
              onChange={(e) => updateField("e_p_s", e.target.value)}
            />
          </label>

          <label className={styles.field}>
            <span>ESI Number</span>
            <input
              value={esiDetails.previous_ESI_number || ""}
              onChange={(e) =>
                updateField("previous_ESI_number", e.target.value)
              }
            />
          </label>

          <label className={styles.field}>
            <span>ESI Dispensary</span>
            <input
              value={esiDetails.esi_dispensary || ""}
              onChange={(e) => updateField("esi_dispensary", e.target.value)}
            />
          </label>
        </div>

        {/* ESI ID card hidden in self onboarding
        <div className={styles.uploadBlock}>
          <span>ESIC Card</span>
          {esiDetails.esi_id_card ? (
            <div className={styles.previewRow}>
              <img
                src={esiDetails.esi_id_card}
                className={styles.imagePreview}
                alt="ESIC card preview"
              />
              <button
                type="button"
                className={styles.removeButton}
                onClick={handleRemoveEsiIdCard}
              >
                Remove File
              </button>
            </div>
          ) : (
            <label className={styles.uploadButton}>
              Upload File
              <input
                type="file"
                className={styles.hiddenInput}
                accept="image/png,image/jpeg,image/jpg"
                onChange={(e) => handleEsiIdCard(e.target.files?.[0])}
              />
            </label>
          )}
        </div>
        */}

        <div className={styles.nomineeHeader}>
          <h3>PART-A (E.P.F)</h3>
          <button
            type="button"
            className={styles.addButton}
            disabled={nominees.length >= 4}
            onClick={() => dispatch(addNominee())}
          >
            Add Nominee
          </button>
        </div>

        {nominees.map((n, index) => (
          <div key={n.id} className={styles.nomineeSection}>
            {index > 0 && (
              <button
                type="button"
                className={styles.removeBtn}
                onClick={() => dispatch(removeNominee(n.id))}
              >
                ×
              </button>
            )}

            <div className={styles.formGrid}>
              <label className={styles.field}>
                <span>
                  Name of the Nominee{index === 0 ? <b>*</b> : null}
                </span>
                <input
                  value={n.name || ""}
                  className={
                    hasNomineeError(n.id, "name") ? styles.inputError : ""
                  }
                  onChange={(e) => updateNominee(n.id, "name", e.target.value.toUpperCase())}
                />
                {hasNomineeError(n.id, "name") && (
                  <p className={styles.fieldError}>Please fill this field</p>
                )}
              </label>

              <label className={styles.field}>
                <span>
                  Address of the Nominee{index === 0 ? <b>*</b> : null}
                </span>
                <input
                  value={n.address || ""}
                  className={
                    hasNomineeError(n.id, "address") ? styles.inputError : ""
                  }
                  onChange={(e) =>
                    updateNominee(n.id, "address", e.target.value.toUpperCase())
                  }
                />
                {hasNomineeError(n.id, "address") && (
                  <p className={styles.fieldError}>Please fill this field</p>
                )}
              </label>

              <label className={styles.field}>
                <span>
                  Nominee Relationship with the members{index === 0 ? <b>*</b> : null}
                </span>
                <select
                  value={n.relationship || ""}
                  className={
                    hasNomineeError(n.id, "relationship")
                      ? styles.inputError
                      : ""
                  }
                  onChange={(e) =>
                    updateNominee(n.id, "relationship", e.target.value)
                  }
                >
                  <option value="">Select</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Spouse">Spouse</option>
                  <option value="Son">Son</option>
                  <option value="Daughter">Daughter</option>
                </select>
                {hasNomineeError(n.id, "relationship") && (
                  <p className={styles.fieldError}>Please select an option</p>
                )}
              </label>

              <label className={styles.field}>
                <span>
                  Share of Provident Fund towards the nominee{index === 0 ? <b>*</b> : null}
                </span>
                <select
                  value={n.share || ""}
                  disabled={totalShare >= 100 && !n.share}
                  className={
                    hasNomineeError(n.id, "share") ? styles.inputError : ""
                  }
                  onChange={(e) => updateNominee(n.id, "share", e.target.value)}
                >
                  <option value="">Select</option>
                  {getAvailableOptions(n.id).map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
                {hasNomineeError(n.id, "share") && (
                  <p className={styles.fieldError}>Please select a share</p>
                )}
              </label>

              <label className={styles.field}>
                <span>
                  Nominee DOB{index === 0 ? <b>*</b> : null}
                </span>
                <input
                  type="date"
                  value={n.dob || ""}
                  className={
                    hasNomineeError(n.id, "dob") ? styles.inputError : ""
                  }
                  onChange={(e) => updateNominee(n.id, "dob", e.target.value)}
                />
                {hasNomineeError(n.id, "dob") && (
                  <p className={styles.fieldError}>Please select a date</p>
                )}
              </label>

              <label className={styles.field}>
                <span>If the Nominee is a minor, name of the guardian</span>
                <input
                  value={n.guardian || ""}
                  onChange={(e) =>
                    updateNominee(n.id, "guardian", e.target.value.toUpperCase())
                  }
                />
              </label>
            </div>

            <div className={styles.uploadBlock}>
              <span>Nominee Image / Document</span>
              {n.image ? (
                <div className={styles.previewRow}>
                  <img
                    src={n.image.url || n.image.s3Url}
                    className={styles.imagePreview}
                    alt="Nominee preview"
                  />
                  <button
                    type="button"
                    className={styles.removeButton}
                    onClick={() => handleRemoveImage(n.id)}
                  >
                    Remove File
                  </button>
                </div>
              ) : (
                <label className={styles.uploadButton}>
                  Upload File
                  <input
                    type="file"
                    className={styles.hiddenInput}
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={(e) => handleImage(n.id, e.target.files?.[0])}
                  />
                </label>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default EsiForm;
